<template>
  <header class="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-3 md:px-6 shadow-sm">
    <!-- 左侧：移动端菜单按钮 -->
    <div class="flex items-center">
      <el-button
        v-if="showMenuButton"
        text
        size="small"
        @click="$emit('menu-click')"
        class="md:hidden mr-2 p-2"
      >
        <el-icon><Menu /></el-icon>
      </el-button>
    </div>
    
    <!-- 中间：系统标题 -->
    <div class="flex-1 flex justify-center">
      <h1 class="text-lg md:text-xl text-gray-800 text-center">
        <span class="hidden sm:inline">信息科学与工程学院教师信息采集系统</span>
        <span class="sm:hidden">教师信息采集系统</span>
      </h1>
    </div>
    
    <!-- 右侧：用户菜单 -->
    <div class="flex justify-end">
      <el-dropdown popper-class="header-dropdown-popper">
        <button class="header-user-trigger flex items-center space-x-2 hover:bg-gray-50 px-2 md:px-3 py-2 rounded-md transition-colors">
          <span class="text-xs md:text-sm text-gray-600">
            <span class="hidden sm:inline">欢迎，{{ teacherName }}老师</span>
            <span class="sm:hidden">{{ teacherName }}</span>
          </span>
          <el-icon class="h-4 w-4 text-gray-500"><ArrowDown /></el-icon>
        </button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item class="logout-item" @click="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
  </header>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { logout, getAuthToken } from '@/api/auth'
import { getMyInfo } from '@/api/user'
import { Menu, ArrowDown } from '@element-plus/icons-vue'

defineProps({
  showMenuButton: {
    type: Boolean,
    default: false
  }
})

defineEmits(['menu-click'])

const teacherName = ref('张三')
const router = useRouter()
const handleLogout = () => {
  try { logout() } catch { /* ignore */ }
  try { router.push('/login') } catch { window.location.href = '/login' }
}

onMounted(() => {
  try {
    const raw = localStorage.getItem('userInfo')
    if (raw) {
      const info = JSON.parse(raw)
      teacherName.value = info?.name || info?.userName || teacherName.value
    }
  } catch { /* ignore */ }
  (async () => {
    try {
      const token = getAuthToken()
      const p = router.currentRoute?.value?.path || ''
      if (!token || p === '/login') return
      const res = await getMyInfo()
      const data = res?.data || res
      const n = data?.name || data?.userName || data?.realName || ''
      if (n) teacherName.value = n
    } catch { /* ignore */ }
  })()
})
</script>

<style scoped>
:deep(.header-dropdown-popper) {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  --el-dropdown-menuItem-hover-color: #111827;
  --el-dropdown-menuItem-hover-fill: #e5e7eb;
}
:deep(.header-dropdown-popper .el-dropdown-menu__item) {
  color: #6b7280 !important;
  border-radius: 6px;
}
:deep(.header-dropdown-popper .el-dropdown-menu__item:hover) {
  background-color: #e5e7eb !important;
  color: #111827 !important;
}

:deep(.header-dropdown-popper .logout-item) {
  color: #6b7280 !important;
}
:deep(.header-dropdown-popper .logout-item:hover) {
  background-color: #e5e7eb !important;
  color: #111827 !important;
}

.header-user-trigger {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.header-user-trigger:focus, .header-user-trigger:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
</style>
